
<template>
    <sirit-modal size="sm">
        <template v-slot:modalContent>
            <div class="flex justify-center items-center flex-col">
                <div class="w-full h-full py-10 text-center ">
                  <span class="text-2xl font-medium mt-2 mb-5 text-center">Vas a salir de TRecupera, ¿Deseas continuar?</span>
                </div>
                <div class="w-8/12  grid grid-cols-2 gap-2 items-center mx-auto">
                    <div class="w-full flex flex-col items-center mx-auto">
                        <button @click="closeModal()" type="submit" class="w-full mt-4 py-2 md:px-6  rounded-md border-2 border-black hover:bg-gray-100 text-black font-bold" >Cancelar</button>
                    </div>
                    <div class="w-full flex flex-col items-center mx-auto">
                        <button @click="logout()" type="submit" class="w-full mt-4 py-2 md:px-6 text-white rounded-md border-2 " :class="`bg-${colors.primary}-500 hover:bg-${colors.primary}-600`" >Aceptar</button>
                    </div>
                </div>
            </div>
        </template>
    </sirit-modal>
</template>

<script lang="ts">
import SiritModal from '@/components/Commons/SiritModal.vue'
import {state} from '@/api/global'

export default {
  name: 'LogoutModal',
  components: {SiritModal},
  emits: ['onFire', 'onFireLogout'],
  props: ['openModal'],
  setup (props: any,{ emit } : any) {

    const { colors } = state.configTenant.template;

    const closeModal = () => {
        emit("onFire")
    }

    const logout = () => {
        emit("onFireLogout")
    }

    return {
      closeModal,
      logout,
      colors,
    }

  }

}

</script>
